import store from "../store";
export default class StereoContext {
  constructor(images, exImages) {

    // Select images such that every image has an adjacent pair
    // If the last image is selected, pair it with the first image
    let selectedImages = images.slice().sort((a, b) => a.exIndex - b.exIndex);
    let maxIndex = Math.max(...exImages.map(i => i.exIndex));
    let pairs = images.map((image, index) => {
      let nextIndex = image.exIndex === maxIndex ? 1 : image.exIndex + 1;
      let nextImage = exImages.find(i => i.exIndex === nextIndex);
      if (!selectedImages.includes(nextImage)) selectedImages.push(nextImage);
      return {
        image1: image,
        image2: nextImage,
        index: index
      };
    });

    this.imagePairs = pairs;
    this.selectedPair = pairs[0];
    this.images = selectedImages;
  }

  refreshImages(){
    return store.dispatch("loadImages_full_thumb", this.images);
  }
}

